
import { API, graphqlOperation } from 'aws-amplify';
import { onCreateCompanyNotificationByGroup } from '@/graphql/subscriptions';
import store from '@/store'
import EventBus from '@/eventBus'
import { decompress } from '@/utilities/apiCallCompressed'

let subscriptionCreate = null
const mapEvents = {
    "INSERT": "onCreate",
    "MODIFY": "onUpdate",
    "REMOVE": "onDelete"
}
const companyNotificationsSubscribe = function(){
    try {
        //Now subscribe to any new additions
        let input = {
            group: store.state.userInfo.tenant.group
        }
        subscriptionCreate = API.graphql(
            graphqlOperation(onCreateCompanyNotificationByGroup, input)
        ).subscribe({
            next: async ({value}) => {
                try {
                    const notificationData = value.data
                    const onCreateCompanyNotificationByGroup = notificationData.onCreateCompanyNotificationByGroup
                    const { affectedTable, message, streamTable } = onCreateCompanyNotificationByGroup
                    if (affectedTable === 'RosterChecklist') {
                        onCreateCompanyNotificationByGroup.deserializedMessage = JSON.parse(message)
                        EventBus.$emit('reload-rchecklist', onCreateCompanyNotificationByGroup);
                    }
                    if(affectedTable === 'Route|ReplaceByRoute'){
                        const message = decompress(onCreateCompanyNotificationByGroup.message)
                        const route = message.data
                        const eventName = mapEvents[message.eventType]

                        EventBus.$emit('update-route-render', {
                            target: "table-data-routes",
                            route,
                            replaceByRouteId: message.replaceByRouteId,
                            from: streamTable === 'Route' ? 'route' : 'replaceByRoute',
                            routeId: route?.id,
                            eventName

                        })
                    }
                } catch (error) {
                    console.log("error route subs",error)
                }
                
            },
            error: async(error)=>{
                console.error('Subscription error:', error);
            }
        });
        // console.log("listening for new company notifications", {subscriptionCreate})

    } catch (error) {
        if(error.message === 'No current user'){
            companyNotificationsUnsubscribe()
        }else{
            console.log('Error: Associate Subscription Failed', error);
        }
    }
}

const companyNotificationsUnsubscribe = async function(){
    subscriptionCreate?.unsubscribe();
    subscriptionCreate = null
    // console.log("Stopped listening to new notifications.", {subscriptionCreate})
}

const handleDailyDailyRosterPath = (to, from) => {
    if(from.name === 'DailyRoster'){
        if(to.name !== 'DailyRoster'){
            companyNotificationsUnsubscribe()
        }
    }else{
        if(to.name === 'DailyRoster'){
            companyNotificationsSubscribe()
        }
    }
}

export {
    companyNotificationsSubscribe,
    companyNotificationsUnsubscribe,
    handleDailyDailyRosterPath
}